import { ConfirmProductVisualizationSchema } from "@redotech/redo-agents-cards/support-agents/confirm-product-visualization";
import * as z from "zod";
import { literal, object, string } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";

/**
 * Customer input content schema for product visualization upload
 * All fields are optional to handle the pending state before upload
 */
export const ProductVisualizationCustomerInputContentSchema = object({
  imageHash: string().optional(),
  imageExtension: string().optional(),
  imageUrl: string().optional(),
});

export type ProductVisualizationCustomerInputContent = z.infer<
  typeof ProductVisualizationCustomerInputContentSchema
>;

/**
 * Message type for when the AI wants the customer to upload a photo
 * for product visualization
 */
const ProductVisualizationUploadMessageSchema =
  BaseToolCallMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_VISUALIZATION_UPLOAD_UI),
    structuredContent: ConfirmProductVisualizationSchema.optional(),
    customerInputContent:
      ProductVisualizationCustomerInputContentSchema.optional(),
  });

export type ProductVisualizationUploadMessage = z.infer<
  typeof ProductVisualizationUploadMessageSchema
>;

export const ProductVisualizationUploadMessageDbParser =
  ProductVisualizationUploadMessageSchema.merge(AutoGeneratedFieldsSchema);

export type ProductVisualizationUploadMessageType = z.infer<
  typeof ProductVisualizationUploadMessageDbParser
>;
